import { useState, useCallback, useContext, useEffect } from "react";
import { useFilters } from "features/filters/store";
import { getIndexMapaTematicoForTipoMapa } from "ui/pages/app/home/util";
import { MdTraffic, MdSchedule, MdAssignment, MdSimCardDownload, MdEventAvailable, MdToday } from "react-icons/md";
import { IoPricetag, IoBarChart } from "react-icons/io5";
import { Container } from "./styles";
import FilterHeader from "./partials/HeaderComponent";
import { useMenuFilterIndex } from "core/features/filters/hooks/useMenuFilterIndex";
import FiltersUnidade from "components/inputs/filter-safra-unidade-mapatematico/items/unidade";
import { CenterMapContext } from "core/features/maps/center-map/CenterMap.context";
import { FilterIndex } from "components/inputs/filter-safra-unidade-mapatematico/enum";
import { useFiltersLists } from "core/features/filters/store/lists";
import { eventLogger } from "infra/events";
import mixpanel from "mixpanel-browser";
import { useAuth } from "core/features/auth/store";
import { useValidatePermission } from "core/features/auth/hooks/useValidatePermission";
import FiltersSafra from "components/inputs/filter-safra-unidade-mapatematico/items/safra";
import { TipoMapaTalhoes } from "core/features/maps/typings";
import { FiltrosAvancados } from "../SideMenu/FiltrosAvancados";
import { FiltrosAvancados as FiltrosAvancadosRelatorio } from "../Relatorios/partials/FiltroAvancado";
import { FiltroAvancadoAderencia as FiltrosAvancadosRelatorioAderencia } from "../Relatorios/partials/FiltroAvancadoAderencia";
import { FiltroAvancadoDiarioOperacoes } from "../Relatorios/partials/FiltroAvancadoDiarioOperacoes";
import { Planejamento } from "../../interfaces/Planejamento";
import { FiltersMapaTematicoPlanoOperacional, ItemProps } from "./partials/FiltersMapaTematicoPlanoOperacional";
import useModalPlanejamentoOperacoes from "ui/pages/app/planejamentoOperacional/hooks/useModalPlanejamentoOperacoes";
import useMapData from "../../hooks/useMapData";
import { FiltroAgendaCampoOpcional } from "../AgendaCampo/partials/FiltroAgendaCampoOpcional";

const RELATORIO_DIARIO_OPERACOES = 'Relat�rio Di�rio de Opera��es';

type Props = {
    filters?: any;
    planoOperacionalData?: Planejamento;
    setFilters: (filters: any) => void;
}

export function SidebarHeader({ planoOperacionalData, filters: filtersData, setFilters }: Props) {
    const { filters, updateField } = useFilters();
    const { unidade, tipoMapa, tabBarSessaoPlanejamentoOperacional, filtersAdvanced, menuNameRelatorios } = filters;
    const [isVisible, setIsVisible] = useState<boolean>(true);
    const { unidades, safras } = useFiltersLists();
    const { handleChangeShouldForceCenter } = useContext(CenterMapContext);
    const { indexOpen, setIndexOpen } = useMenuFilterIndex();
    const { user } = useAuth();
    const { hasPermission } = useValidatePermission();
    const canViewRdo = hasPermission(['Relatorios.RelatorioDiarioOperacoesAgricolas']);
    const { setShowLegends } = useModalPlanejamentoOperacoes();
    const { setDatas } = useMapData();

    const hasGestaoJustificativaPermission = hasPermission(["GestaoJustificativas.Visualizar"]);

    const LIST_TYPES_MAPS: ItemProps[] = [
        {
            id: '1',
            nome: 'Mapa Cronograma',
            enabled: true,
            icon: MdSchedule,
        },
        {
            id: '2',
            nome: 'Mapa Semáforo',
            enabled: true,
            icon: MdTraffic,
        },
        {
            id: '3',
            nome: 'Gestão de O.S.',
            enabled: true,
            icon: MdAssignment,
        },
        ...(hasGestaoJustificativaPermission ?
            [{
                id: '4',
                nome: 'Gestão de Justificativa',
                enabled: true,
                icon: IoPricetag
            }]
            : []),
    ];

    const LIST_TYPES_REPORTS: ItemProps[] = [
        {
            id: '1',
            nome: 'Relatório Analítico Operacional',
            enabled: true,
            icon: MdSimCardDownload,
        },
        {
            id: '2',
            nome: 'Relatório de Programação Operacional',
            enabled: true,
            icon: IoBarChart,
        },
        {
            id: '3',
            nome: 'Relatório de Aderência Operacional',
            enabled: true,
            icon: MdEventAvailable,
        },
    ];

    if (canViewRdo) {
        LIST_TYPES_REPORTS.push({
            id: '4',
            nome: RELATORIO_DIARIO_OPERACOES,
            enabled: true,
            icon: MdToday,
        });
    }

    const handleOpen = useCallback(
        (index: number) => {
            const currentIndexOpen = useMenuFilterIndex.getState().indexOpen;
            const _index =
                currentIndexOpen === index
                    ? getIndexMapaTematicoForTipoMapa(tipoMapa)
                    : index;

            setIndexOpen(_index);
        },
        [setIndexOpen, tipoMapa]
    );

    useEffect(() => {
        if (
            planoOperacionalData?.filtrosAvancados?.ocupacoes?.length === 0 &&
            planoOperacionalData?.filtrosAvancados?.safraPeriodos?.length === 0 &&
            planoOperacionalData?.filtrosAvancados?.operacaoClasses?.length === 0
        ) {
            updateField("filtersAdvanced", {
                ...filtersAdvanced,
                cultura: '',
                safraPeriodo: '',
                classeOperacao: [],
            })
        }
    }, [])

    useEffect(() => {
        if (menuNameRelatorios === RELATORIO_DIARIO_OPERACOES && !canViewRdo) {
            updateField('menuNameRelatorios', 'Relatório Analítico Operacional');
        }
    }, [menuNameRelatorios, canViewRdo, updateField]);

    const showFiltroAvancadoAnalitico =
        tabBarSessaoPlanejamentoOperacional === 'relatorios'
        && menuNameRelatorios !== 'Relatório de Aderência Operacional'
        && menuNameRelatorios !== RELATORIO_DIARIO_OPERACOES;

    return (
        <Container>
            <FilterHeader
                indexOpen={indexOpen}
                onToggle={(index) => handleOpen(index)}
                isMenuVisible={isVisible}
                handleOpenMenu={() => setIsVisible(true)}
                nameDefault="Planejamento Operacional"
                tabBarSelected={tabBarSessaoPlanejamentoOperacional}
            />
            {tabBarSessaoPlanejamentoOperacional === 'cadastros' && (
                <div style={{ position: 'absolute', left: 440, top: 0 }}>
                    <FiltrosAvancados filtersData={planoOperacionalData?.filtrosAvancados} />
                </div>
            )}
            {tabBarSessaoPlanejamentoOperacional === 'agenda-campo' && (
                <div style={{ position: 'absolute', left: 440, top: 0 }}>
                    <FiltroAgendaCampoOpcional filtersData={planoOperacionalData?.filtrosAvancados} />
                </div>
            )}
            {showFiltroAvancadoAnalitico && (
                <div style={{ position: 'absolute', left: 440, top: 0 }}>
                    <FiltrosAvancadosRelatorio
                        filtersData={planoOperacionalData?.filtrosAvancados}
                    />
                </div>
            )}
            {tabBarSessaoPlanejamentoOperacional === 'relatorios' && menuNameRelatorios === 'Relatório de Aderência Operacional' && (
                <div style={{ position: 'absolute', left: 440, top: 0 }}>
                    <FiltrosAvancadosRelatorioAderencia
                        filtrosAvancados={planoOperacionalData?.filtrosAvancados}
                    />
                </div>
            )}
            {tabBarSessaoPlanejamentoOperacional === 'relatorios' && menuNameRelatorios === RELATORIO_DIARIO_OPERACOES && (
                <div style={{ position: 'absolute', left: 440, top: 0 }}>
                    <FiltroAvancadoDiarioOperacoes
                        filtersData={planoOperacionalData?.filtrosAvancados}
                    />
                </div>
            )}
            {indexOpen === FilterIndex.Unidade ? (
                <FiltersUnidade
                    unidadeSelected={unidade || undefined}
                    data={unidades}
                    onClick={(item) => {
                        handleChangeShouldForceCenter(true);
                        updateField("setor", null);
                        updateField("unidade", item);
                        setIndexOpen(getIndexMapaTematicoForTipoMapa(tipoMapa));
                        mixpanel.track(
                            `Unidade_${item.nome}`,
                            eventLogger(user?.email as string)
                        );
                        setFilters({ ...filtersData, unidadeid: item.id });
                        updateField("filtersAdvanced", {
                            ...filtersAdvanced,
                            cultura: '',
                            safraPeriodo: '',
                            classeOperacao: [],
                        });
                    }}
                />
            ) : null}

            {indexOpen === FilterIndex.Safra ? (
                <FiltersSafra
                    data={safras}
                    onClick={(item) => {
                        updateField("setor", null);
                        updateField("safra", item);

                        if (tipoMapa === TipoMapaTalhoes.OperacoesExecutadas) {
                            setIndexOpen(FilterIndex.Operacoes_Executadas);
                        } else if (tipoMapa === TipoMapaTalhoes.Satelite) {
                            setIndexOpen(FilterIndex.Imagens_Satelite);
                        } else if (tipoMapa === TipoMapaTalhoes.NumeroDeAplicacoes) {
                            setIndexOpen(FilterIndex.Numero_De_Aplicacoes);
                        } else if (tipoMapa === TipoMapaTalhoes.Produtividade) {
                            setIndexOpen(FilterIndex.Produtividade);
                        } else if (tipoMapa === TipoMapaTalhoes.ConcentracaoColheita) {
                            setIndexOpen(FilterIndex.Concentracao_Colheita);
                        } else {
                            setIndexOpen(FilterIndex.Ocupacao);
                        }
                        setFilters({ ...filtersData, safraid: item.id });
                        updateField("filtersAdvanced", {
                            ...filtersAdvanced,
                            cultura: '',
                            safraPeriodo: '',
                            classeOperacao: [],
                        });
                    }}
                />
            ) : null}

            {tabBarSessaoPlanejamentoOperacional !== 'cadastros' && indexOpen === FilterIndex.Mapa_Tematico ? (
                <FiltersMapaTematicoPlanoOperacional
                    data={tabBarSessaoPlanejamentoOperacional === 'execucao-operacional' ? LIST_TYPES_MAPS : LIST_TYPES_REPORTS}
                    onClose={() => setIndexOpen(getIndexMapaTematicoForTipoMapa(tipoMapa))}
                    onClick={(item) => {
                        mixpanel.track(
                            `MapaTematico_${item}`,
                            eventLogger(user?.email as string)
                        );
                        setIndexOpen(item.filterMenuIndex);
                        if (tabBarSessaoPlanejamentoOperacional === 'execucao-operacional') {
                            updateField('menuName', item);
                        }
                        if (tabBarSessaoPlanejamentoOperacional === 'relatorios') {
                            updateField('menuNameRelatorios', item);
                        }
                        setDatas([]);
                        setShowLegends(false);
                    }}
                />
            ) : null}
        </Container>
    )
}